import axios from 'axios';
import history from './history';

const BASE_URL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
	baseURL: BASE_URL,
	timeout: 50000,
	headers: {
		accept: 'application/json',
		Authorization: localStorage.getItem('access_token')
			? 'Bearer ' + localStorage.getItem('access_token')
			: null,
		// 'ngrok-skip-browser-warning': 'any',
	},
});

let isRefreshing = false;
let refreshSubscribers = [];

function onRefreshed(newAccessToken) {
  refreshSubscribers.forEach((cb) => cb(newAccessToken));
  refreshSubscribers = [];
}

function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

// Logout helper
const setLogout = () => {
	console.log("Logging out...");
	localStorage.clear();
	history.replace('/');
};

// Request interceptor:
axiosInstance.interceptors.request.use(
	(config) => {
		return config;
	},
	(error) => Promise.reject(error)
);


// Response interceptor: Handle 401 and refresh token
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve) => {
          subscribeTokenRefresh((newAccessToken) => {
            originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
            resolve(axiosInstance(originalRequest));
          });
        });
      }

      isRefreshing = true;

      try {
        const refresh = localStorage.getItem('refresh_token');
        if (!refresh) {
          setLogout();
          return Promise.reject(error);
        }

        let remember_me = false;
        try {
          remember_me = JSON.parse(localStorage.getItem('remember_me')) || false;
        } catch (e) {}

        const res = await axios.post(`${BASE_URL}accounts/token/refresh/?remember_me=${remember_me}`, { refresh });

        const newAccess = res.data.access;
        const newRefresh = res.data.refresh;

        localStorage.setItem('access_token', newAccess);
        if (newRefresh) {
          localStorage.setItem('refresh_token', newRefresh);
        }

        axiosInstance.defaults.headers['Authorization'] = `Bearer ${newAccess}`;
        originalRequest.headers.Authorization = `Bearer ${newAccess}`;

        onRefreshed(newAccess); // notify queued subscribers
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        setLogout();
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);


export default axiosInstance;
